import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import "../index.css"
import { FaBars } from "react-icons/fa";
import { ImCross } from "react-icons/im";

const Navbar = () => {
    const [mobile, setMobile] = useState(false)
    return (
        <div>
            {/* <nav className='navbar'>
                <div> <img src='https://sedge.in/New%20College/assest/logo.png' className='logo' /> </div>
                <ul className={mobile ? "navlinks-mobile" : 'navlinks'} onClick={() => setMobile(false)}>
                    <Link to='/'> <li>Home</li> </Link>
                    <Link to='/activies'> <li>Activies</li> </Link>
                    <Link to='/facilities'> <li>Facilities</li> </Link>
                    <Link to='/alumini'> <li>Alumini</li> </Link>
                </ul>

                <button className='mobile-Menu-Icon' onClick={() => setMobile(!mobile)}>
                    {
                        mobile ? <ImCross /> : <FaBars />
                    }

                </button>

            </nav> */}
            <nav className='navbar2'>
            <div> <img src='https://thenewcollege.edu.in/images/New%20logo%20banner.png' className='logo' /> </div>
                <ul className={mobile ? "navlinks-mobile" : 'navlinks'} onClick={() => setMobile(false)}>
                    <Link to='/grievances'> <li>Grievances</li> </Link>
                    <Link to='/nirfa'> <li>NIRF</li> </Link>
                    <Link to='/moe'> <li>MoE</li> </Link>
                    <Link to='/payment'> <li>Online Payment</li> </Link>
                    <Link to='/exam'> <li>Examinations</li> </Link>
                    <Link to='/research'> <li>Research</li> </Link>
                    <Link to='/iqac'> <li>IQAC</li> </Link>
                </ul>
            </nav>

        </div>
    );
}

export default Navbar;
